import { SKILL_MANAGEMENT } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { skillList } from "../../../constants/interface/skill";

const initialState: skillList = {
  skillmanagementList: [] as any,

  apidata: [] as any,
  skill_name: "",
  skill_description: "",
  no_of_agnt_sk: "",
  status: 1,
 
};
const SkillSettingsSlice = createSlice({
  name: SKILL_MANAGEMENT,
  initialState,
  reducers: {
    skillManagement: (state, { payload }) => {
      state.skillmanagementList = payload.skillmanagementList;
    
    },
    createValue: (state, { payload }) => {
      state.skillmanagementList = payload.skillmanagementList;
    },
    updateValue: (state, { payload }) => {
      state.skillmanagementList = payload.skillmanagementList;
    },
    apiValue: (state, { payload }) => {
      state.apidata = payload.apidata;
    },

    reset: () => {},
  },
});
export const SkillSettingsActions = SkillSettingsSlice.actions;
export default SkillSettingsSlice.reducer;
